import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconStatusInitiated = createIcon({
  viewBox: '0 0 48 48',
  path: (
    <>
      <defs>
        <path
          id="zoyqoyoxea"
          d="M21 29.571L18.429 27 18 30l3-.429zm-1.5-3.763l2.692 2.692L30 20.692 27.308 18 19.5 25.808zm8.771-8.85l2.77 2.77c.612.613.612 1.605 0 2.217l-8.495 8.494c-.24.24-.55.396-.886.444l-4.266.609c-.428.061-.825-.236-.886-.665-.01-.073-.01-.148 0-.221l.61-4.266c.047-.336.203-.647.442-.886l8.495-8.495c.612-.612 1.604-.612 2.216 0z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <circle
            cx="24"
            cy="24"
            r="16.125"
            fill="#3D6CB4"
            stroke="#FFF"
            strokeWidth="3.75"
          />
          <circle
            cx="24"
            cy="24"
            r="17.25"
            stroke="#3D6CB4"
            strokeWidth="1.5"
          />
        </g>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#zoyqoyoxea" />
      </g>
    </>
  ),
});

export default IconStatusInitiated;
